import { useMemo } from "react";
import { AxnIdentityProvider } from "@idw-types/data/reference-data/axn";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { resources } from "@constants/hardcoded-strings";

type LoginIdpSelectFormGroupProps = BaseSelectFormGroupProps & {
    axnIdentityProviders: Array<AxnIdentityProvider>
};

export const LoginIdpSelectFormGroup = (props: LoginIdpSelectFormGroupProps) => {
    const { axnIdentityProviders, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const idpOptions = useMemo(() => {
        return axnIdentityProviders.map(idp => ({ label: idp.name, value: idp.code }));
    }, [axnIdentityProviders]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-login-idp-select`}
            label={resources.common.inputs.loginIdp.label}
            ariaLabel={resources.common.inputs.loginIdp.label}
            automationId={`${idPrefix}-login-idp-select`}
            onChange={onChange}
            options={idpOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};